const TOKEN_STORAGE_KEY = "TIENDAS:JWT:TOKEN";
const USER_DATA_STORAGE_KEY = "TIENDAS:USER:DATA";

export { TOKEN_STORAGE_KEY, USER_DATA_STORAGE_KEY };
